import { Injectable } from '@angular/core';
import { ApiService } from '@app/gateway';
import { CertificateModel } from '../models';
import { BaseRepository } from './base';
import { FactoryRepository } from './factory';

@Injectable({ providedIn: 'root' })
export class CertificateRepository extends BaseRepository<CertificateModel> {
  constructor(
    protected override readonly factoryRepository: FactoryRepository,
    protected override readonly apiService: ApiService
  ) {
    super(factoryRepository, apiService);
  }

  protected getModelName(): string {
    return 'CertificateFactory';
  }
}
